import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    // 头部导航条当前选中
    localPath: sessionStorage.getItem('localPath')||'home',
  },
  mutations: {
    SET_LOCAL_PATH: (state,path) => {
      sessionStorage.setItem('localPath',path);
      state.localPath = path;
    },
  },
  actions: {},
  modules: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.ts